/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowFatLineLeft(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M114.34277,229.65723l-96-96a8.003,8.003,0,0,1,0-11.31446l96-96A8.00065,8.00065,0,0,1,128,32V72h56a8.00039,8.00039,0,0,1,8,8v96a8.00039,8.00039,0,0,1-8,8H128v40a8.00066,8.00066,0,0,1-13.65723,5.65723ZM216,184a8.00039,8.00039,0,0,0,8-8V80a8,8,0,0,0-16,0v96A8.00039,8.00039,0,0,0,216,184Z" />
    </Svg>
  );
}

export default ArrowFatLineLeft;
